import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { EqBaseComponent } from '../eq-base/eq-base.component';
const Material = [
  MatInputModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatFormFieldModule,
  MatRippleModule,
  MatIconModule,
];
@Component({
  selector: 'eq-date-range-picker',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ...Material],
  templateUrl: './date-range-picker.component.html',
  styleUrl: './date-range-picker.component.scss',
})
export class DateRangePickerComponent extends EqBaseComponent {
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  
  override ngOnInit(): void {
    super.ngOnInit();
  
    if (this.controlName) {
      const initial = this.controlName.value;
      if (initial?.start && initial?.end) {
        this.range.patchValue({
          start: new Date(initial.start),
          end: new Date(initial.end)
        }, { emitEvent: false });
      }
  
      this.controlName.valueChanges.subscribe((value: any) => {
        if (value?.start && value?.end) {
          this.range.patchValue({
            start: new Date(value.start),
            end: new Date(value.end)
          }, { emitEvent: false });
        } else {
          this.range.reset({ start: null, end: null }, { emitEvent: false });
        }
      });
    }
  }
  
  clearFilter(event: any) {
    event.preventDefault();
    this.form.get(this.name)?.reset();
    this.range.reset();
  }
  onDateChange(event: any) {
    const v = this.range.value;
    if(v.start && v.end){
      this.form.get(this.name)?.setValue(v);
    }
  }
}
